import { Signal } from '@angular/core';
import { Translation } from '@softline/ui-core';

export abstract class PageFilterComponentBase {
  abstract title: Signal<Translation>;
  abstract canBack: Signal<boolean>;
  abstract canApply: Signal<boolean>;
  abstract tabsVisible: Signal<boolean>
  abstract back?: () => void
  abstract apply?: () => void
  reset?: () => void
  cancel?: () => void
}
